<template>
  <div class="image-uploader">
    <div v-if="!this.myCropper">
      <el-upload
        ref="imageUploader"
        class="avatar-uploader"
        action="上传路径"
        :auto-upload="this.autoUpload"
        :show-file-list="false"
        :http-request="upload"
        :on-change="uploadChange"
        :before-upload="beforeAvatarUpload"
      >
        <img
          v-if="fileForm.fileUrl"
          :src="fileForm.fileUrl"
          class="avatar"
          :style="{ width: fileForm.width, height: fileForm.height }"
        />
        <img
          v-else-if="uploadImgPreview"
          :src="uploadImgPreview"
          class="avatar"
          :style="{ width: fileForm.width, height: fileForm.height }"
        />
        <i
          v-else
          class="el-icon-plus avatar-uploader-icon"
          :style="{
            width: fileForm.width,
            height: fileForm.height,
            lineHeight: fileForm.height
          }"
        ></i>
      </el-upload>
    </div>
    <div v-else>
      <el-upload
        class="avatar-uploader photo"
        action="上传路径"
        :auto-upload="this.autoUpload"
        :show-file-list="false"
        :on-change="photoChange"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="fileForm.fileUrl" :src="fileForm.fileUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        <span id="avatar-uploader"></span>
      </el-upload>
      <el-dialog
        custom-class="width-900"
        title="裁剪头像"
        center
        :visible.sync="photoDialogVisible"
        size="tiny"
        v-cloak
      >
        <div class="modal-body">
          <div :style="{ width: realWidth + 'px', height: realHeight + 'px' }">
            <img class="photoCropper" id="photoCropper" />
          </div>
          <div class="view1">
            <span>预览：</span>
            <img :src="photoPre" />
          </div>
          <div class="view2">
            <img :src="photoPre" />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="clickPhotoChange" round
            >更换图片</el-button
          >
          <el-button type="primary" @click="uploadModal" round
            >开始上传</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.min.css";
import { upload } from "@/api/document";
import { apiConfig } from "../config/api";
export default {
  props: {
    cropper: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    uploadDir: {
      type: String,
      default: function() {
        return "";
      }
    },
    width: {
      type: Number,
      default: function() {
        return 0;
      }
    },
    height: {
      type: Number,
      default: function() {
        return 0;
      }
    },
    value: {
      type: String,
      default: function() {
        return "";
      }
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    fileName: {
      type: String,
      default: function() {
        return "";
      }
    }
  },
  data() {
    return {
      fileForm: {
        docId: null,
        fileUrl: "",
        width: this.width === 0 ? "auto" : this.width + "px",
        height: this.height === 0 ? "auto" : this.height + "px"
      },
      myCropper: this.cropper,
      myValue: "",
      realWidth: 0,
      realHeight: 0,
      photoPre: "",
      uploadImgPreview: "",
      photoDialogVisible: false,
      cropperObj: null
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    value(val) {
      this.myValue = val;
    },
    myValue(val) {
      this.fileForm.docId = val;
    },
    "fileForm.docId"(val) {
      if (val && val.length > 0) {
        if (val.indexOf("data:image") > -1) {
          this.fileForm.fileUrl = val;
        } else {
          this.fileForm.fileUrl = apiConfig.document.api.download.url + val;
        }
      } else {
        this.fileForm.fileUrl = "";
      }
    }
  },
  methods: {
    init() {
      this.myValue = this.value;
    },
    beforeAvatarUpload(file) {
      let isImage = file.type === "image/jpeg" || file.type === "image/png";
      let isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("只能上传png、jpg格式图片!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isImage && isLt2M;
    },
    upload(data) {
      let that = this;
      // 先要获取后端签名
      that.loadingInstance = that.$loading({ lock: true, text: "拼命上传中" });
      let fileName = that.fileName
        ? that.fileName + ".png"
        : that.random_string(6) + "_" + new Date().getTime() + ".png";

      let param = new FormData(); // 创建form对象
      param.append("file", data.file);
      param.append("filename", fileName);
      param.append("dir", this.uploadDir);

      upload(param, {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" },
        //添加上传进度监听事件
        onUploadProgress: function(e) {
          console.log("进度：");
          console.log(e);
          //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
          //如果lengthComputable为false，就获取不到e.total和e.loaded
          if (e.lengthComputable) {
            data.onProgress({ percent: (e.loaded / e.total) * 100 });
          }
        }
      })
        .then(res => {
          if (res.code === "200") {
            // 上传完成
            data.onSuccess();
            that.success(res.data);
            that.loadingInstance.close();
            that.$message({
              message: "上传成功",
              type: "success"
            });
            this.$emit("uploadCallback");
          }
        })
        .catch(err => {
          console.log(err);
          that.loadingInstance.close();
          that.$message.error("上传失败，请重新上传");
        });
    },
    uploadModal() {
      let arr = this.photoPre.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let file = new File([u8arr], "test.png", { type: mime });
      let that = this;
      // 先要获取后端签名
      that.loadingInstance = that.$loading({ lock: true, text: "拼命上传中" });
      let fileName =
        that.random_string(6) +
        "_" +
        new Date().getTime() +
        "." +
        file.name.split(".").pop();
      that
        .multipartUpload(
          that.uploadDir + "/" + fileName,
          file
          //  , {
          //   progress: function* (percentage, cpt) {
          //     // 上传进度
          //     that.percentage = percentage
          //     console.log(percentage)
          //   }
          // }
        )
        .then(results => {
          // 上传完成
          // const url = 'http://photo.chinahrtt.com/' + results.name
          that.success(results);
          that.loadingInstance.close();
          that.photoDialogVisible = false;
          that.$message({
            message: "上传成功",
            type: "success"
          });
        })
        .catch(err => {
          console.log(err);
          that.loadingInstance.close();
          that.photoDialogVisible = false;
          that.$message.error("上传失败，请重新上传");
        });
    },
    photoChange(file) {
      let that = this;
      // 先要获取后端签名
      let reader = new FileReader();
      reader.onload = event => {
        let img = new Image();
        img.onload = () => {
          that.photoDialogVisible = true;
          that.realWidth = img.width > 400 ? 400 : img.width;
          that.realHeight = img.height > 400 ? 400 : img.height;
          that.$nextTick(() => {
            let image = document.getElementById("photoCropper");
            if (!that.cropperObj) {
              that.cropperObj = new Cropper(image, {
                aspectRatio: 1,
                viewMode: 1,
                minContainerWidth: 180,
                minContainerHeight: 180,
                background: false,
                movable: false,
                rotatable: false,
                zoomable: false,
                zoomOnWheel: false,
                zoomOnTouch: false,
                guides: false,
                center: false,
                crop: () => {
                  that.photoPre = that.cropperObj
                    .getCroppedCanvas({
                      width: 180,
                      height: 180
                    })
                    .toDataURL("image/png");
                }
              });
            }
            that.cropperObj.replace(img.src);
          });
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file.raw);
    },
    uploadChange(file) {
      if (this.autoUpload) {
        return;
      }
      let isImage =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      let isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("只能上传png、jpg格式图片!");
        return;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return;
      }
      var reader = new FileReader();
      let that = this;
      reader.onload = e => {
        that.uploadImgPreview = e.target.result;
        that.$emit("input", that.uploadImgPreview);
      };
      reader.readAsDataURL(file.raw);
    },
    clickPhotoChange() {
      let span = document.getElementById("avatar-uploader");
      let imageUploader = span.parentNode;
      imageUploader.click();
    },
    random_string(len) {
      len = len || 32;
      let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      let maxPos = chars.length;
      let pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    success(results) {
      this.fileForm.docId = results.docId;
      this.$emit("input", this.fileForm.docId);
    },
    submit() {
      this.$refs["imageUploader"].submit();
    }
  }
};
</script>

<style lang="scss">
.image-uploader {
  .width-900 {
    width: 900px;
  }
  .modal-body {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0 50px;
    .photoCropper {
      max-width: 400px;
      max-height: 400px;
    }
    .view1 {
      width: 120px;
      height: 140px;
      margin-left: 10px;
      flex-direction: column;
      span {
        display: block;
        height: 20px;
        line-height: 10px;
      }
      img {
        width: 120px;
        height: 120px;
        border: 1px solid #f3f3f3;
      }
    }
    .view2 {
      width: 120px;
      height: 120px;
      margin-left: 10px;
      flex-direction: column;
      img {
        width: 120px;
        height: 120px;
        border-radius: 60px;
        border: 1px solid #f3f3f3;
      }
    }
  }
  .avatar-uploader {
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &:hover {
        border-color: #409eff;
      }
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px !important;
      height: 178px !important;
      line-height: 178px !important;
      text-align: center;
    }
  }
  .avatar {
    width: 178px !important;
    height: 178px !important;
    display: block;
    &.logo {
      border-radius: 100%;
    }
  }
  .photo {
    .el-upload {
      border-radius: 100%;
      img {
        border-radius: 100%;
      }
    }
  }
}
</style>
